import React from 'react';
import type { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import { faPause } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { faPlay } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { Spinner } from '@components/basics/Spinner';

export const DynamicCoverImagePlayButton = ({
  coverImageUrl,
  title,
  isPlaying,
  onPlayClick,
  isLoading,
  className,
  nextImageSizes,
  playButtonSize = 'lg',
}: {
  coverImageUrl: string;
  title: string;
  isPlaying: boolean;
  onPlayClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isLoading: boolean;
  className?: string;
  nextImageSizes: string;
  playButtonSize?: SizeProp;
}) => {
  return (
    <div
      className={twMerge(
        'relative mr-2 h-full w-full flex-shrink-0 overflow-hidden rounded-md',
        className,
      )}
    >
      <Image src={coverImageUrl} fill sizes={nextImageSizes} alt={title} />

      <button
        className={`absolute inset-0 flex cursor-pointer items-center justify-center transition-opacity duration-300 ease-in-out group-hover:opacity-100 ${
          isPlaying ? 'opacity-100' : 'lg:opacity-0'
        }`}
        onClick={onPlayClick}
        color="transparent"
      >
        <div className="absolute inset-0 bg-black/20 " />
        <div className="z-above1">
          {isLoading ? (
            <Spinner className=" text-white" />
          ) : (
            <>
              {isPlaying ? (
                <FontAwesomeIcon icon={faPause} size={playButtonSize} className=" text-white" />
              ) : (
                <FontAwesomeIcon
                  icon={faPlay}
                  size={playButtonSize}
                  className="ml-0.5 text-white"
                />
              )}
            </>
          )}
        </div>
      </button>
    </div>
  );
};
